Papa = require "papaparse"

module.exports = () ->
  return {
    scope:
      onGenerate: "&mappingGeneratorOnGenerate"
      getSchema: "&mappingGeneratorGetSchema"
      getTemplate: "&mappingGeneratorGetTemplate"

    controller: ($scope, $interpolate) ->
      $scope.gridOptions = {}
      $scope.selections = {}
      $scope.currentSelection = null
      $scope.currentIndex = null

      @getColumnDef = (name) ->
        return unless name?.length > 0
        return columnDef for columnDef in $scope.gridOptions?.columnDefs or [] when columnDef.name is name

      $scope.gridOptions.onRegisterApi = (gridAPI) ->
        $scope.gridAPI = gridAPI
        gridAPI.cellNav.on.navigate $scope, (newRowCol, oldRowCol) ->
          if $scope.currentSelection?
            $scope.updateSelections(newRowCol)

      $scope.updateSelections = (newRowCol) ->
        if $scope.currentIndex?
          if $scope.currentSelection not of $scope.selections
            $scope.selections[$scope.currentSelection] = []
          $scope.selections[$scope.currentSelection][$scope.currentIndex] = [newRowCol.col.colDef.name]
        else
          $scope.selections[$scope.currentSelection] = newRowCol.col.colDef.name
        $scope.currentSelection = null
        $scope.currentIndex = null

      $scope.addInput = (selection) ->
        if selection not of $scope.selections
          # for the first click on `add field` we need to initialize field
          # in $scope.selections and add two arrays to display two inputs
          $scope.selections[selection] = []
          $scope.selections[selection].push []
        $scope.selections[selection].push []

      $scope.changeSelection = (selection, index) =>
        $scope.currentSelection = selection
        $scope.currentIndex = if index? then index else null
        if $scope.currentIndex?
          if $scope.selections[selection]? and $scope.selections[selection][$scope.currentIndex]?
            selectedColumn = @getColumnDef($scope.selections[selection][$scope.currentIndex][0])
        else
          selectedColumn = @getColumnDef($scope.selections[selection])
        if selectedColumn? and $scope.gridAPI?
          $scope.gridAPI.cellNav.scrollToFocus($scope.gridOptions.data[0], selectedColumn)

      $scope.handleGenerate = () ->
        generated = JSON.parse($interpolate($scope.getTemplate())($scope))
        $scope.onGenerate({mapping: generated})

      $scope.removeMapping = (index, selection) ->
        $scope.selections[selection].splice index, 1

      $scope.loadFile = (files) ->
        return unless files?.length > 0

        $scope.fileName = files[0].name

        Papa.parse(files[0], {
          header: true
          preview: 10
          complete: (res) ->
            $scope.$apply ->
              $scope.gridOptions.columnDefs = for columnName, _ of res.data[0]
                continue unless columnName?.length > 0
                {name: columnName, width: '150'}
              $scope.gridOptions.data = res.data
        })

    template: require("./mapping-generator.html")
  }
